export default {
  path: "/order_management",
  name: "Order Management",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      component: () => import("@/views/order-management/Index"),
    },
  ],
};
